import moment from 'moment-timezone';

const throttle = async (time) => new Promise((resolve) => setTimeout(resolve, time));

// const parseDate = (date = new Date()) => {
//   const momentDate = moment(date);
//   const timeZoneOffset = -momentDate.toDate().getTimezoneOffset() / 60;
//   return {
//     week: momentDate.isoWeek(),
//     day: momentDate.utcOffset(timeZoneOffset).set({ hours: timeZoneOffset, minutes: 0, seconds: 0, milliseconds: 0 }).toDate(),
//     monday: momentDate.utc().isoWeekday(1).startOf('day').toDate(),
//     sunday: momentDate.utc().isoWeekday(7).startOf('day').toDate(),
//     monthStart: momentDate.utc().startOf('month').toDate(),
//     monthEnd: momentDate.utc().endOf('month').toDate(),
//     yearStart: momentDate.utc().startOf('year').toDate(),
//     yearEnd: momentDate.utc().endOf('year').toDate(),
//   };
// };

const parseDate = (date = new Date()) => {
  if (!(date instanceof Date) && !isNaN(Number(date))) {
    date = new Date(Number(date));
  }
  const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const momentDate = moment.tz(date, timezoneString);

  return {
    week: momentDate.isoWeek(),
    weekDay: momentDate.isoWeekday(),
    now: momentDate.toDate(),
    day: momentDate.startOf('day').toDate(),
    monday: momentDate.clone().isoWeekday(1).startOf('day').toDate(),
    sunday: momentDate.clone().isoWeekday(7).startOf('day').toDate(),
    monthStart: momentDate.clone().startOf('month').toDate(),
    monthEnd: momentDate.clone().endOf('month').toDate(),
    yearStart: momentDate.clone().startOf('year').toDate(),
    yearEnd: momentDate.clone().endOf('year').toDate(),
    addDays(days) {
      const newDate = momentDate.clone().add(days, 'days').toDate();
      return parseDate(newDate);
    },
    getDateDifference(date2 = new Date()) {
      const momentDate1 = moment(date2);
      const momentDate2 = moment(date);

      if (!momentDate1.isValid() || !momentDate2.isValid()) {
        throw new Error('Invalid date format. Please provide valid dates.');
      }

      const difference = momentDate2.diff(momentDate1, 'days');

      return difference;
    },
  };
};

function compareObjects(obj1, obj2) {
  const changedProperties = [];
  (function recursiveCompare(obj1, obj2) {
    for (const prop in obj1) {
      if (typeof obj1[prop] === 'object' && obj1[prop] && obj2[prop]) {
        recursiveCompare(obj1[prop], obj2[prop])
      }
      else if (obj1.hasOwnProperty(prop)) {
        if (obj1[prop] !== obj2[prop])
          changedProperties.push(prop);
      }
    }
  })(obj1, obj2);

  return changedProperties;
}

export { throttle, parseDate, compareObjects };